import { Message, Spinner } from 'Components/Core';
import Page from 'Components/Pages/Core/Page';
import {
  WorksheetBatchUpdateConflictResolutionDialog,
  WorksheetBatchUpdateQuerySection,
  WorksheetBatchUpdateUpdateDataSection,
} from 'Components/WorksheetBatchUpdate/Core';
import FixedWorksheetBatchUpdateHeader from 'Components/WorksheetBatchUpdate/Core/Header/FixedWorksheetBatchUpdateHeader';
import WorksheetBatchUpdateSelectionGrid from 'Components/WorksheetBatchUpdate/Core/WorksheetBatchUpdateSelectionGrid';
import { actions as appActions } from 'Data/ReduxViewModels/App';
import { TitleSource } from 'Data/ReduxViewModels/App/types';
import { actions } from 'Data/ReduxViewModels/WorksheetBatchUpdate';
import { useUrlSearchParams } from 'Lib/Hooks';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './WorksheetBatchUpdatePage.scss';

const WorksheetBatchUpdatePage: React.FC = () => {
  const dispatch = useDispatch();

  const uriParams = useUrlSearchParams();

  useEffect(() => {
    dispatch(actions.setUriParams({ uriParams: Object.fromEntries(uriParams.entries()) }));
  }, [dispatch, uriParams]);
  const testMethodCaption = useSelector((state) => state.worksheetBatchUpdate.worksheetCaption);
  const isInitialised = useSelector((state) => state.worksheetBatchUpdate.status.initialised);
  const isBusy = useSelector((state) => state.worksheetBatchUpdate.status.refreshingWorksheets);
  const isQueryReady = useSelector((state) => state.worksheetBatchUpdate.status.queryReady);
  const worksheetsLoaded = useSelector(
    (state) => state.worksheetBatchUpdate.worksheets && Object.values(state.worksheetBatchUpdate.worksheets).length > 0
  );

  const SpinnerComponent = (
    <div style={{ position: 'relative', height: '100%' }}>
      <Spinner large />
    </div>
  );

  const title = testMethodCaption ? `Batch Update - ${testMethodCaption}` : 'Batch Update';
  useEffect(() => {
    dispatch(appActions.setPageTitle({ pageTitle: title, source: TitleSource.Specific }));
    return () => {
      dispatch(appActions.setPageTitle({ pageTitle: undefined, source: TitleSource.Specific }));
    };
  }, [dispatch, title]);

  return (
    <Page>
      <div className="WorksheetBatchUpdatePage">
        <FixedWorksheetBatchUpdateHeader pageIdentifier={title} />
        {isInitialised ? (
          <>
            <WorksheetBatchUpdateConflictResolutionDialog />
            <WorksheetBatchUpdateQuerySection />
            <WorksheetBatchUpdateUpdateDataSection />
            <div className="WorksheetBatchUpdateSelectionGridSection">
              {isBusy ? (
                SpinnerComponent
              ) : worksheetsLoaded ? (
                <WorksheetBatchUpdateSelectionGrid />
              ) : isQueryReady ? (
                <div style={{ padding: '20px' }}>
                  <Message>No results found.</Message>
                </div>
              ) : null}
            </div>
          </>
        ) : null}
      </div>
    </Page>
  );
};

export default WorksheetBatchUpdatePage;
